<template>
  <div>
    <Navbar />
    <div class="subNav">
      <div class="xcl-sub-nav">
        <div class="xcl-sub-nav-inner">
          <a class="sub-nav-item active" style="font-weight: 700; position: relative; left: 40px" href="#old-carousel" @click.prevent="scrollToSection('old-carousel')">XCL for Die Casting</a>
          <a class="sub-nav-item sub-right" href="#processes" @click.prevent="scrollToSection('processes')">Processes</a>
          <a class="sub-nav-item sub-right" href="#materials" @click.prevent="scrollToSection('materials')">Materials</a>
          <a class="sub-nav-item sub-right" href="#capabilities" @click.prevent="scrollToSection('capabilities')">Capabilities</a>
          <a class="sub-nav-item sub-right" href="#post-processing" @click.prevent="scrollToSection('post-processing')">Post Processing</a>
        </div>
      </div>
    </div>

    <div class="main-page-content">
      <section class="fct-hero-im" id="old-carousel">
        <div class="hero-bg-wrap">
           <img src="@/assets/banner/5.png" alt="3D Printing" class="hero-bg-img">
          <div class="hero-mask"></div>
        </div>
        <div class="container">
          <div class="content-block">
            <h1 class="hero-title">Custom Die Casting Services</h1>
            <div class="desc">
              <p>Custom die casting manufacturing for aluminum, zinc and magnesium alloy components.</p>
            </div>
             <ul class="feature-list">
              <li class="feature-item">
                <span class="check-icon">✓</span>
                <span class="text-content">Quick prototype die casting in short time</span>
              </li>
              <li class="feature-item">
                <span class="check-icon">✓</span>
                <span class="text-content">Precision die cast parts for industrial & consumer applications</span>
              </li>
              <li class="feature-item">
                <span class="check-icon">✓</span>
                <span class="text-content">Complete tooling design and process optimization</span>
              </li>
              <li class="feature-item">
                <span class="check-icon">✓</span>
                <span class="text-content">Low MOQ available for small batch and mass production</span>
              </li>
            </ul>
            <div class="btn-group">
              <span class="btn btn-cnc-quote" @click="$router.push('/quote')">Get Die Casting Quote</span>
              <p class="text-small">All uploads files are safe and confidential</p>
            </div>
          </div>
        </div>
      </section>

      <section class="cert-section">
        <div class="container">
          <div class="cert-list">
            <div v-for="(item, index) in list" :key="index" class="cert-item">
              <svg class="check-icon-svg" width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="11" fill="#16bc9c" />
                <path d="M8 12.5 L11 15.5 L16 9.5" stroke="#222222" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" fill="none" />
              </svg>
              <div class="cert-text">
                <div v-for="(line, lineIndex) in item.lines" :key="lineIndex" class="text-line">{{ line }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Die_Services id="processes"/>
      <Die_Capabilities id="capabilities"/>
      <Die_Materials id="materials"/>
      <Die_FinishingOptions id="post-processing"/>
      <Die_Part/>
      <Die_Why/>
      <Die_together/>
      <Footer/>
    </div>
  </div>
</template>

<script>
import { ref, onUnmounted } from 'vue';

import Footer from '../components/Footer.vue';
import Navbar from '../components/Nav.vue';
import Die_Services from './components/Die_Services.vue';
import Die_Materials from './components/Die_Materials.vue';
import Die_FinishingOptions from './components/Die_FinishingOptions.vue';
import Die_Capabilities from './components/Die_Capabilities.vue';
import Die_Part from './components/Die_Part.vue';
import Die_Why from './components/Die_Why.vue';
import Die_together from './components/Die_together.vue';

export default {
  name: 'Die-Casting',
  components: { Footer, Navbar, Die_Services, Die_Materials, Die_FinishingOptions, Die_Capabilities, Die_Part, Die_Why, Die_together },
  setup() {
    const list = ref([
      { lines: ["ISO 9001:2015", "Certified"] },
      { lines: ["Samples as fast as", "8-15 days"] },
      { lines: ["Technical support on design", "and manufacturing"] },
      { lines: ["Robust quality control", "and testing procedures"] },
    ]);

    const scrollToSection = (sectionId) => {
      const element = document.getElementById(sectionId);
      if (!element) return;

      const isMobile = window.innerWidth <= 1024;
      const navbarHeight = isMobile ? 65 : (65 + 76); 
      const elementPosition = element.offsetTop - navbarHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }

    const handleImageError = (e) => {
      e.target.src = "https://via.placeholder.com/520x260/eeeeee/66666?text=Image+Error";
    };
    
    return {
      list,
      handleImageError,
      scrollToSection
    };
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

/* 二级导航 */
.subNav {
  width: 100%;
  height: 76px;
  background: #fff;
  border-bottom: none;
  position: fixed;
  top: 65px;
  left: 0;
  z-index: 998;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
}

.xcl-sub-nav {
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 1px rgba(78, 78, 78, .05);
  position: relative;
  z-index: 50 !important;
  height: 100%;
  top: 0;
}

.xcl-sub-nav-inner {
  max-width: 1200px;
  margin: 0 auto;
  height: 78%;
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 0 20px;
}

.sub-nav-item {
  font-size: 16px;
  color: #505050;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
}

.active:hover {
  color: #0e957b;
}

.sub-right {
  position: relative;
  right: -587px;
  transition: color .3s;
}

.sub-right:hover {
  color: #0e957b !important;
}

.sub-right::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: #0e957b;
  transition: all .3s;
}

.sub-right:hover::after {
  width: 100%;
}

/* section 样式 */
.fct-hero-im {
  position: relative;
  width: 100%;
  min-height: 525px;
  padding: 60px 0;
  overflow: hidden;
  background: #ffffff;
}

.hero-bg-wrap {
  position: absolute;
  top: 0;
  right: 280px; 
  width: 65%;
  height: 100%;
  z-index: 1;
}

.fct-hero-im .container {
  padding: 0 608px 0 0;
}

.hero-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0.9;
  display: block;
}

.hero-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 70%;
  height: 100%;
  background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0.95) 40%, rgba(255, 255, 255, 0) 100%);
  z-index: 2;
}

.container {
  position: relative;
  z-index: 3;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 115px;
}

.content-block {
  width: 80%;
  margin: 0 auto;
  text-align: left;
}

.hero-title {
  font-size: 42px;
  font-weight: 600;
  color: #333333;
  line-height: 1.15;
  margin-bottom: 1.5rem;
  font-family: inherit;
  white-space: nowrap;
  overflow: visible;
}

.desc p {
  font-size: 1rem;
  color: #555555;
  line-height: 1.7;
  margin-bottom: 12px;
  font-family: inherit;
  font-weight: 500;
}

.feature-list {
  list-style: none;
  margin: 0 0 30px 0;
  padding: 0;
}

/* 列表及图标对齐核心样式 */
.feature-item {
  display: flex;
  align-items: flex-start; 
  font-size: 16px;
  color: #505050;
  margin-bottom: 12px; 
  line-height: 1.5; 
  font-weight: 500;
}

.check-icon {
  color: #16bc9c;
  font-weight: bold;
  margin-right: 12px;
  font-size: 20px;
  flex-shrink: 0; 
  line-height: 24px; 
}

.text-content {
  flex: 1; 
}

.btn-group {
  margin: 30px 0;
}

.btn-cnc-quote {
  display: inline-block;
  background-color: #16bc9c;
  color: #ffffff;
  font-size: 1rem;
  padding: 14px 29px;
  border-radius: 4px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: color 0.4s;
}

.btn-cnc-quote::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: #027062;
  transition: all 0.4s;
  z-index: -1;
}

.btn-cnc-quote:hover::before {
  left: 0;
}

.text-small {
  font-size: 0.75rem;
  color: #17202a;
  margin-top: -3px;
  font-weight: 600;
}

/* ================= 1024px 中等屏幕适配及隐藏二级导航 ================= */
@media (max-width: 1024px) {
  .subNav {
    display: none !important;
  }
  
  .main-page-content {
    margin-top: -45px;
  }

  .content-block {
    width: 100%;
    text-align: left; 
  }
  .hero-title {
    font-size: 32px; 
    white-space: normal;
  }
  .desc p {
    font-size: 1.1rem;
  }
  .btn-cnc-quote {
    font-size: 1.2rem;
    padding: 14px 30px;
  }
  .hero-bg-wrap {
    width: 100%;
    right: 0;
  }
  .hero-mask {
    width: 100%;
    background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0.4) 100%);
  }
  .fct-hero-im .container {
    padding: 0 40px; 
  }
}

/* ================= 移动端列表文字居中问题 (768px 及以下生效) ================= */
@media (max-width: 768px) {
  .container {
    padding: 0 20px !important; 
  }
  
  .fct-hero-im .container {
    padding: 0 20px !important;
  }

  .feature-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start; 
  }

  .feature-item {
    justify-content: flex-start; 
    width: 100%;
  }

  .text-content {
    flex: 1; 
    text-align: left; 
    max-width: 100%; 
  }
}

/* ============== 证书 Section PC端基础样式 ============== */
.cert-section {
  background-color: #222222 !important;
  height: 212px !important;
  display: flex;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
}

.cert-list {
  display: flex;
  justify-content: space-between !important;
  align-items: flex-start !important;
  flex-wrap: nowrap !important;
  width: 100%;
  gap: 18px;
}

.cert-item {
  display: flex;
  align-items: flex-start !important;
}

/* ========== 图标与文字间隙调整 ========== */
.check-icon-svg {
  flex-shrink: 0 !important;
  margin-top: -2px !important;
  margin-right: 6px !important; 
}

/* ========== 文字排版对齐 ========== */
.cert-text {
  display: flex;
  flex-direction: column;
  gap: 4px !important;
  text-align: left !important; 
}

.text-line {
  font-size: 16px !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
  margin: 0 !important;
  font-family: inherit !important;
  white-space: nowrap !important;
}

/* ================= 证书 Section - iPad 及中等屏幕适配 (覆盖 1024px，解决溢出问题) ================= */
@media (max-width: 1024px) {
  .cert-list {
    flex-wrap: wrap !important;
    gap: 30px 20px !important; 
    justify-content: flex-start !important;
  }
  .cert-item {
    width: calc(50% - 10px) !important; 
    justify-content: flex-start !important; 
  }
  .cert-text {
    text-align: left !important;
  }
  .cert-section {
    height: auto !important;
    padding: 40px 30px !important;
  }
}

/* ================= 证书 Section 移动端专属适配 (仅少于768px，即 767px 及以下触发单列) ================= */
@media (max-width: 767px) {
  .cert-section {
    padding: 40px 20px !important;
  }
  .cert-list {
    flex-direction: column !important; 
    align-items: flex-start !important; 
    gap: 28px !important; 
  }
  .cert-item {
    width: 100% !important; 
    justify-content: flex-start !important; 
  }
  .cert-text {
    text-align: left !important; 
  }
  .text-line {
    white-space: normal !important; 
  }
}

/* ================= 专门针对 PC 端 (> 1024px) 调整证书栏靠左以对齐 XCL ================= */
@media (min-width: 1025px) {
  .cert-section .container {
    padding-left: 70px !important; 
    padding-right: 80px !important; 
  }
}
</style>